export const DEFAULT_ANIMATION = 'none';
/** Shows the envelope already open, with nothing animated. See `DIGITAL_ENVELOPE_ANIMATIONS`. */
export const NO_REVEAL_ANIMATION = 'reallyNone';
export const DEFAULT_ENVELOPE_COLOR = '#FFFFFF';
export const DEFAULT_BACKGROUND_COLOR = '#F7F7F7';

export const DIGITAL_WALLPAPER_COLORS = [
  {
    value: DEFAULT_BACKGROUND_COLOR,
  },
  {
    value: '#FFFFFF',
  },
  {
    value: '#F4F2EC',
  },
  {
    value: '#FFE9E9',
  },
  {
    value: '#CCB99A',
  },
  {
    value: '#494949',
  },
  {
    value: '#D8E897',
  },
  {
    value: '#C5D0BF',
  },
  {
    value: '#3D4D41',
  },
  {
    value: '#D2E1F3',
  },
  {
    value: '#5176B0',
  },
  {
    value: '#263E5C',
  },
  {
    value: '#DED0E5',
  },
  {
    value: '#553E75',
  },
  {
    value: '#E7524D',
  },
  {
    value: '#6B0D2E',
  },
  {
    value: '#FFED93',
  },
  {
    value: '#BA5D3E',
  },
  {
    value: '#876554',
  },
];

export const DIGITAL_ENVELOPE_COLORS = [
  {
    value: '#FFFFFF',
  },
  {
    value: '#F8E8D2',
  },
  {
    value: '#E1E1E1',
  },
  {
    value: '#F9D6CE',
  },
  {
    value: '#494949',
  },
  {
    value: '#C3DE5A',
  },
  {
    value: '#86C150',
  },
  {
    value: '#778B71',
  },
  {
    value: '#D2E1F3',
  },
  {
    value: '#A7D1D9',
  },
  {
    value: '#4784B5',
  },
  {
    value: '#263E5C',
  },
  {
    value: '#CCB9D6',
  },
  {
    value: '#FFA6C5',
  },
  {
    value: '#9D1E4B',
  },
  {
    value: '#CA0919',
  },
  {
    value: '#FFB33E',
  },
  {
    value: '#BA5D3E',
  },
  {
    value: '#A88165',
  },
];

/**
 * The ids and their labels (translated in `DigitalEnvelope`) deliberately disagree. `none` predates
 * the no-animation option and still plays the envelope opening, so it is labelled "Envelope";
 * `reallyNone` is the one with no animation at all, labelled "None". Stored drafts hold these ids, so
 * neither can be renamed.
 */
export const DIGITAL_ENVELOPE_ANIMATIONS = ['confetti', DEFAULT_ANIMATION, NO_REVEAL_ANIMATION] as const;
